import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxUiLoaderConfig, NgxUiLoaderModule, NgxUiLoaderRouterModule, SPINNER } from 'ngx-ui-loader';
import { NgxFileDropModule } from 'ngx-file-drop';
import { JwtModule } from '@auth0/angular-jwt';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutsModule } from './layouts/layouts.module';
import { LoginComponent } from './auth/login/login.component';
import { EmailVerifyComponent } from './auth/email-verify/email-verify.component';
import { SignUpComponent } from './auth/signup/signup.component';
import { NotLoggedInComponent } from './auth/not-logged-in/not-logged-in.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { EmailResetPasswordComponent } from './auth/email-reset-password/email-reset-password.component';
import { TokenInterceptor } from './services/token-interceptor.service';
import { TablePaginationComponent } from './shared/table-pagination/table-pagination.component';
import { UiModule } from './UI/ui/ui.module';
import { GetImage } from './helpers/getImage';
import { HierarchyChunkComponent } from './components/hierarchy-chunk/hierarchy-chunk.component';
import { BrowserUtilityService } from './services/browser-utility.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HistoryService } from './services/history.service';

declare const require: any;

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: '#OOACC1',
  bgsOpacity: 0.5,
  bgsType: SPINNER.rectangleBounce,
  fgsColor: '#337AB7',
  fgsType: SPINNER.ballScaleMultiple,
};

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    EmailVerifyComponent,
    EmailResetPasswordComponent,
    SignUpComponent,
    PasswordResetComponent,
    NotLoggedInComponent,
  ],
  exports: [ReactiveFormsModule],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    LayoutsModule,
    FormsModule,
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule.forRoot({ excludeRegexp: ['/browser', '/mapset-browser'] }),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    UiModule,
    NgxFileDropModule,
    BrowserAnimationsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('access_token');
        },
      },
    }),
  ],
  providers: [
    GetImage,
    HierarchyChunkComponent,
    TablePaginationComponent,
    BrowserUtilityService,
    HistoryService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
  ],
})
export class AppModule {}
